<template>
    <div class="bg-grey full-height">
    
        <CRow class="m-0 justify-content-center align-items-center">
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 5px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Upload Image</span>
                </h5>
    
            </CCol>
    
            <CCol sm="8" class="text-center mt-5" style="width: 90%; background-size: cover; margin: auto;">
               
                  <img style="max-width:100px" src="../assets/img/userreal.png" />
                  <h1 class="custom-20px-600 mt-2">Hello Alif</h1>
                  <label class="custom-12px-600">Nice Photo!</label>

                  <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToWishes()">Next</CButton>
                  <label class="text-center custom-14px-500-blue mt-3">Change Image</label>
                </CCol>

        
    
        </CRow>

      
    </div>
</template>


<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,
            isLanguagePopupVisible1: false,
            code: ["", "", "", ""],

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },

        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/RegisterHomepage");
        },

        GoToChangePassword() {
            // Close the popup and backdrop
            this.$router.push("/ChangePassword");
        },
        submitVerification() {
            // const verificationCode = this.code.join(""); // Concatenate the digits
            // console.log("Verification Code:", verificationCode);

            // this.popupSuccess = true;

            this.isLanguagePopupVisible = true;
            

            // Add your logic to handle the verification code
        },

        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToWishes()
        {
            this.isLanguagePopupVisible1 = true;

        },
        closePopup1() {
            this.isLanguagePopupVisible = false;
            this.$router.push("UploadImage");
        },

    }
})
</script>
